import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Transition as _Transition, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../../assets/logo.png';
const _hoisted_1 = {
  class: "outer-container-header"
};
const _hoisted_2 = {
  class: "container-fluid long-container"
};
const _hoisted_3 = {
  class: "container"
};
const _hoisted_4 = {
  class: "navbar navbar-default long-header"
};
const _hoisted_5 = {
  class: "container-fluid long-nav"
};
const _hoisted_6 = {
  class: "navbar-header"
};
const _hoisted_7 = {
  style: {
    "width": "1160px"
  },
  class: "collapse navbar-collapse",
  id: "bs-example-navbar-collapse-1"
};
const _hoisted_8 = {
  class: "nav navbar-nav navbar-right long-nav-font"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("nav", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_Transition, {
    name: "logo",
    appear: "",
    class: "animate__animated",
    "enter-active-class": "animate__backInDown"
  }, {
    default: _withCtx(() => [_createVNode(_component_router_link, {
      class: "navbar-brand logo",
      to: "/home"
    }, {
      default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createElementVNode("img", {
        src: _imports_0,
        alt: "logo"
      }, null, -1)]))]),
      _: 1
    })]),
    _: 1
  }), _createElementVNode("button", {
    type: "button",
    class: "navbar-toggle long-collapsed",
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.changeMobileList && $setup.changeMobileList(...args))
  }, [_createElementVNode("div", {
    class: _normalizeClass({
      'bar-hover': $setup.showMobileList,
      'bar-unhover': !$setup.showMobileList
    })
  }, [...(_cache[2] || (_cache[2] = [_createElementVNode("span", {
    class: "icon-bar"
  }, null, -1), _createElementVNode("span", {
    class: "icon-bar"
  }, null, -1), _createElementVNode("span", {
    class: "icon-bar"
  }, null, -1)]))], 2)])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("ul", _hoisted_8, [_createElementVNode("li", null, [_createVNode(_component_router_link, {
    "active-class": "long-liHover",
    to: "/home"
  }, {
    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode("首页", -1)]))]),
    _: 1
  })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
    "active-class": "long-liHover",
    to: "/product"
  }, {
    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode("平台介绍", -1)]))]),
    _: 1
  })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
    "active-class": "long-liHover",
    to: "/news"
  }, {
    default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode("最新咨询", -1)]))]),
    _: 1
  })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
    "active-class": "long-liHover",
    to: "/excellect"
  }, {
    default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode("优秀案例", -1)]))]),
    _: 1
  })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
    "active-class": "long-liHover",
    to: "/service"
  }, {
    default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode("服务与保障", -1)]))]),
    _: 1
  })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
    "active-class": "long-liHover",
    to: "/contact"
  }, {
    default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode("联系我们", -1)]))]),
    _: 1
  })])])])])])])])]);
}